// extracted by mini-css-extract-plugin
export default {"tag":"IDBKsJVFNKVhSmYXdeoF","arrow":"MtibSFezsqbsHbCN6f5k","bounce":"MWyWfODGnp5lRccTYbq0"};